
import Vue from "vue";

import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { FlowTypes } from "@/types/StepsType";

@Component({
  name: "Steps",
})
export default class Steps extends Vue {
  @Getter readonly flow!: FlowTypes;

  @Getter readonly step!: number;

  @Getter readonly deliveryChip!: number;

  stepsData = [
    {
      icon: "mdn-Icon-minha-claro",
      title: "Dados Pessoais",
      flows: ["MIGRATION", "PORTABILITY", "DELIVERY"],
      id: 2,
    },
    {
      icon: "mdn-Icon-localizacao",
      title: "Endereço",
      flows: ["MIGRATION", "PORTABILITY", "DELIVERY"],
      id: 3,
    },
    {
      icon: "mdn-Icon-senha",
      title: "Telefone",
      flows: ["MIGRATION", "PORTABILITY"],
      id: 4,
    },
    {
      icon: "mdn-Icon-frete",
      title: "Entrega",
      flows: ["DELIVERY"],
      id: 5,
    },
    {
      icon: "mdn-Icon-financeiro",
      title: "Forma de pagamento",
      flows: ["MIGRATION", "PORTABILITY", "DELIVERY"],
      id: 6,
    },
    {
      icon: "mdn-Icon-portabilidade",
      title: "Portabilidade",
      flows: ["PORTABILITY"],
      id: 7,
    },
  ];
}
